import React from "react";
import { Table, Checkbox } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { updateUI } from "../../../store/actions/shipment";
import SelectedProfile from "./selectedProfile";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime"; 
import { RadioButtonGroup } from "@vds/radio-buttons";

function ShipmentCloneStep2() {
  const dispatch = useDispatch();
  dayjs.extend(relativeTime);
  const selectedProfileId = useSelector((state) => state.shipment.ui.clone.selectedProfileId); 
  const isCheckboxChecked = useSelector((state) => state.shipment.ui.clone.isCheckboxChecked); 
  const shipmetProfile = useSelector((state) => state?.shipment?.data?.shipProfile);
  const { editField } = useSelector((state) => ({
    editField: state.shipment.ui.clone.editField,
  }));

  function getShipmentByid(profileid, key) {
    const item = shipmetProfile?.find(obj => obj?.profileid === profileid);
    return item ? item[key] : null;
  }
  const handleCheckboxChange = (event) => {
    const  id  = event;
  if(selectedProfileId !== id){
    dispatch(updateUI({
      key: "clone",
      value: {
        selectedProfileId: id,
        isCheckboxChecked:true,
      },      
    }))
    dispatch(updateUI({
      key: "clone",
      value: {
        editField: {
          ...editField,
          selectProfile: {
            value: {
              ...editField.selectProfile.value, 
              id:id,
              name: getShipmentByid(selectedProfileId, "profilename"),
            },
          },
        },
      },
    }));
  }else{
   dispatch(updateUI({
    key: "clone",
    value: {
      selectedProfileId: null,
      isCheckboxChecked:false,
    },
  }))
}
  };

  const profileData = shipmetProfile
   ?.filter((item) => editField?.devicetype?.value === item?.devicetype  && item?.profiletype !=="nonshipment")
  .map((item) => ({
    devicemodel: (
      <li key={item?.profileid}>
        <RadioButtonGroup
                      onChange={(e) => handleCheckboxChange(e.target.value)}
                      error={false}
                      key={item?.profileid}
                      id={item?.profileid}
                      value={selectedProfileId || "undefined"} // Ensure value is defined
                      data={[
                        {
                          name: 'profile-selection', // same name to group radios
                          label: '',
                          children: item?.profilename,
                          value: item?.profileid,
                          ariaLabel: `Select ${item?.profilename}`,
                          disabled: false,
                        },
                      ]}
                    />
        {/* <input
          checked={selectedProfileId === item?.profileid}
          type="checkbox"
          className="ble-checkbox"
          id={item?.profileid}
          value={item?.devicetype}
          onChange={handleCheckboxChange}
        /> */}
          {/* {item?.profilename} */}
      </li>
    ),
    updatedon: dayjs(item?.updatedon).fromNow(),
    createdon: dayjs(item?.createdon).format("MM-DD-YY [at] hh:mm:ss a"),
    createdby: item?.createdby,
  }));

  const columns = [
    {
      title: <span className="font-face-vzw">Profile Name</span>,
      dataIndex: "devicemodel",
      key: "devicemodel",
      width: 250, 
      onHeaderCell: () => ({
        "data-tooltip": "",
      }),
      render: (text) => {
          return (
      <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
        {text}
      </div>
    );
       // return text;
      },
    },
    {
      title: <span className="font-face-vzw">Updated</span>,
      dataIndex: "updatedon",
      key: "updatedon",
      width: 100, 
    },
    {
      title: <span className="font-face-vzw">Created</span>,
      dataIndex: "createdon",
      key: "createdon",
      width: 150, 
    },
    {
      title: <span className="font-face-vzw">Created&#160;by</span>,
      dataIndex: "createdby",
      key: "createdby",
      width: 100, 
    },
  ];

  // const isProfileSelected =
  //   Object.keys(editField.profile.value).length === 0 ||
  //   (Object.keys(editField.profile.value).length > 0 &&
  //     Object.keys(editField.profile.value).filter(
  //       (spkey) => editField.profile.value[spkey]
  //     ).length === 0);

  return (
    <div className="py-3 shipment-clone-step2-container">
      <div
        className="font-face-vzw"
        style={{
          fontWeight: 700,
          fontSize: "20px",
          marginBottom:"2%"
        }}
      >
        Choose Profile
      </div>
      <Table 
        dataSource={profileData}
        columns={columns}
        pagination={false} />

   {!selectedProfileId ? (
  <div className="shipment-clone-step2-info">
    Select a profile to show profile summary
  </div>
) : (
  <SelectedProfile />
)}
    </div>
  );
}

export default ShipmentCloneStep2;
